import $ from 'jquery';
import _ from 'lodash';
import { getState } from '~src/state';
import { scrollToTop } from '~loader/loader-utils';

const collapseContainer = (containerName, html) => {
  $(`#container-${containerName}`)
    .addClass('collapseBoxContainers')
    .addClass(`bg-color-${containerName}`);
  $(`#editor-${containerName}`).hide();
  $(`#${containerName}-container-title`).hide();
  $('#requestFormat').hide();
  $(`#editor-${containerName}-collapsed`).html(html);
  scrollToTop();
};

const showBoxContainer = (containerName) => {
  $(`#container-${containerName}`)
    .removeClass('collapseBoxContainers')
    .removeClass(`bg-color-${containerName}`);
  $(`#editor-${containerName}`).show();
  $('#requestFormat').show();
  $(`#${containerName}-container-title`).show();
  $(`#editor-${containerName}-collapsed`).empty();
  scrollToTop();
};

export const templateCollapseBox = () => {
  const projectType = getState('selected.tipo');
  const format = getState('selected.formato');
  const servizio = getState('selected.servizio');

  if (projectType && projectType.name) {
    const selectedProjectHtmlBlock = `
      <h4 class="loader-container-title">
            Progetto
      </h4>
      <div class="collapse-container-item-title">
        <div class="collapsed-box-text text-center btn-collapse-title color-project-type-on-hover" data-container-collapse="projects">${projectType.name}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
            <path fill-rule="evenodd" d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </div>
      </div>
    `;
    collapseContainer('projects', selectedProjectHtmlBlock);
  }

  if (servizio && servizio.cognome && servizio.nome) {
    const selectedServizioHtmlBlock = `
    <h4 class="loader-container-title">
      Servizio
    </h4>
    <div class="collapse-container-item-title">
        <div class="collapsed-box-text text-center btn-collapse-title color-servizio-on-hover" data-container-collapse="servizio">${servizio.cognome} ${servizio.nome}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
            <path fill-rule="evenodd" d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </div>
    </div>
    `;

    collapseContainer('servizio', selectedServizioHtmlBlock);
  }

  if (format !== 'undefined' && _.isEmpty(format) === false) {
    const selectedFormatHtmlBlock = `
      <h4 class="loader-container-title">
      Formato
      </h4>
      <div class="collapse-container-item-title">
          <div class="collapsed-box-text text-center btn-collapse-title color-format-on-hover" data-container-collapse="formats">${format.name}
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="currentColor">
              <path fill-rule="evenodd" d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </div>
      </div>
    `;
    collapseContainer('formats', selectedFormatHtmlBlock);
  } else {
    showBoxContainer('formats');
  }
};
